import cn from "classnames";
import { useEffect, useRef, useState } from "react";
import { USER_ROLES, useRoles } from "@rshbintech.dboul/access-control";
import { NotificationsHeader } from "./notifications-header";
import { NotificationsContent } from "./notifications-content";
import { NotificationsFooter } from "./notifications-footer";
import { NotificationsProps } from "./types";
import { SERVICE_MANAGEMENT_SETTINGS_KEY } from "./constants";
import styles from "./styles.scss";

export const Notifications = ({
  className,
  clientSettings,
  notificationsList,
  onCloseNotificationsPopup,
}: NotificationsProps) => {
  const { hasRoleThatContains } = useRoles();
  const notificationsListContainerRef = useRef<HTMLDivElement>(null);
  const [contentContainerOverlap, setContentContainerOverlap] = useState({
    top: false,
    bottom: false,
  });

  const isServiceManagementAvailable =
    hasRoleThatContains(USER_ROLES.INFORM_MANAGEMENT) &&
    !!clientSettings?.settings?.notifications?.some(
      ({ key, value }) =>
        key === SERVICE_MANAGEMENT_SETTINGS_KEY && value === "true"
    );

  /* Функция определяющая находится ли скрол в начальном/конечном положении */
  const getContentContainerOverlaps = () => {
    const notificationsListContainer = notificationsListContainerRef?.current;

    return {
      top: notificationsListContainer
        ? notificationsListContainer.scrollTop > 0
        : false,
      bottom: notificationsListContainer
        ? !(
            notificationsListContainer.scrollHeight -
              notificationsListContainer.scrollTop <=
            notificationsListContainer.clientHeight
          )
        : false,
    };
  };

  const handleContentContainerScroll = () => {
    const notificationsListContainerOverlaps = getContentContainerOverlaps();

    setContentContainerOverlap(notificationsListContainerOverlaps);
  };

  useEffect(() => {
    setContentContainerOverlap(getContentContainerOverlaps());
  }, []);

  return (
    <div className={cn(styles.container, className)}>
      <NotificationsHeader
        isServiceManagementAvailable={isServiceManagementAvailable}
        onCloseNotificationsPopup={onCloseNotificationsPopup}
        className={cn({
          [styles.shadow]: contentContainerOverlap.top,
        })}
      />
      <NotificationsContent
        notificationsList={notificationsList}
        onScroll={handleContentContainerScroll}
        containerRef={notificationsListContainerRef}
      />
      <NotificationsFooter
        className={cn({
          [styles.shadow]: contentContainerOverlap.bottom,
        })}
        onCloseNotificationsPopup={onCloseNotificationsPopup}
      />
    </div>
  );
};
